import React, { Fragment, useState, useEffect } from "react";
import Footer from "../layouts/Footer";
import Topbar from "../layouts/TopBar";
import EventResources from "../resources/EventResources";
import { toast } from "react-toastify";
import moment from "moment/moment";
import { connect } from "react-redux";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Index({isLoggedIn, loggedInUser}){
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        centerPadding: '50px', // Add padding on the sides
        slidesToShow: 3, // Adjust based on your need
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      };

    const [events, setEvents] = useState([])

    const loadEvents = () => {
        let resources = new EventResources()
        return resources.get_adminhomepage()
    }

    useEffect(() => {
        loadEvents().then(response => {
            setEvents(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });
    }, []);
    return(
	<Fragment>	
		{/* <!-- Topbar --> */}
		<header className="topbar">
			<div style={{backgroundColor:"#ffa800"}} className="container">
				<ul className="social-icons topmenu pull-right">
                    <li className="facebook"><a href="https://www.facebook.com/TLChurchLondon/" target="_blank"><i className="fa fa-facebook-f"></i></a></li>
					<li className="instagram"><a href="https://www.instagram.com/tlchurchlondon/" target="_blank"><i className="fa fa-instagram"></i></a></li>
					<li className="youtube"><a href="https://www.youtube.com/@TheLibertyChurchLondon" target="_blank"><i className="fa fa-youtube-play"></i></a></li>
				</ul>
				
				<div className="header-info-col">
					<i className="fa fa-envelope-o"></i> <strong>av@thelibertychurchlondon.com</strong>
				</div>
			</div>
		</header>		
        <Topbar/>
	{/* <!-- Hero Area --> */}
    <div className="hero-area">
        <div style={{position: 'relative', width: '100%', overflow: 'hidden', minHeight: '320px', maxHeight: '520px'}}>
            <img
                src="https://ik.imagekit.io/seyi/Tlc_Media/Site_Images/backgroundimage.jpeg"
                alt=""
                style={{width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', position: 'absolute', top: 0, left: 0, bottom: 0, right: 0}}
            />
            <div style={{position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '320px', maxHeight: '520px', padding: '40px 20px'}}>
                <a style={{backgroundColor: '#003165', color: '#fff', padding: '12px 28px', borderRadius: '4px', textDecoration: 'none', fontWeight: 'bold', fontSize: 'clamp(14px, 3.8vw, 16px)'}} href="/about">Who are We</a>
            </div>
        </div>
    </div>
    <div className="featured-links row" style={{display: 'flex', margin: 0}}>
        <a href="https://www.thelibertychurchlondon.com/" target="_blank" className="col-md-4 col-sm-4" style={{backgroundColor: '#003165', color: '#fff', padding: '18px 16px', textDecoration: 'none', textAlign: 'center', flexGrow: 1, borderRight: '1px solid rgba(255,255,255,0.15)'}}>
            <span style={{display: 'block', color: '#ffa800', fontSize: 'clamp(11px, 3vw, 13px)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px'}}>Main Site</span>
            <strong style={{fontSize: 'clamp(14px, 3.8vw, 16px)'}}>The Liberty Church</strong>
        </a>
        <a href="/events" className="col-md-4 col-sm-4" style={{backgroundColor: '#ffa800', color: '#003165', padding: '18px 16px', textDecoration: 'none', textAlign: 'center', flexGrow: 1, borderRight: '1px solid rgba(0,49,101,0.15)'}}>
            <span style={{display: 'block', color: '#003165', fontSize: 'clamp(11px, 3vw, 13px)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px'}}>View Upcoming</span>
            <strong style={{fontSize: 'clamp(14px, 3.8vw, 16px)'}}>Events involving Media</strong>
        </a>
        <a href="/mediabooking" className="col-md-4 col-sm-4" style={{backgroundColor: '#003165', color: '#fff', padding: '18px 16px', textDecoration: 'none', textAlign: 'center', flexGrow: 1}}>
            <span style={{display: 'block', color: '#ffa800', fontSize: 'clamp(11px, 3vw, 13px)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px'}}>Have an Upcoming Event</span>
            <strong style={{fontSize: 'clamp(14px, 3.8vw, 16px)'}}>Request the Media Team</strong>
        </a>
    </div>	

	{/* <!-- Main Content --> */}
    <div id="main-container">
    	<div className="content">       	
        
            <div className="spacer-50"></div>
            <div  className="featured-blocks padding-tb75 lgray-bg">
        		<div className="container">
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <a href="/teamdistribution" className="featured-block">
                                <img src="https://ik.imagekit.io/seyi/Tlc_Media/Site_Images/distribution.jpg" alt="" className="fblock-image"/>
                                <span className="fblock-image-overlay"></span>
                                <span className="fblock-text"><span className="fblock-text-tb">
                                    <span className="fblock-text-tbcell"><strong>Team Distribution across Locations</strong></span>
                                </span></span>
                            </a>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <a href="/about" className="featured-block">
                                <img src="https://ik.imagekit.io/seyi/Tlc_Media/Site_Images/featured.jpg" alt="" className="fblock-image"/>
                                <div className="fblock-image-overlay"></div>
                                <span className="fblock-text"><span className="fblock-text-tb">
                                    <span className="fblock-text-tbcell"><strong>Media Team Members</strong></span>
                                </span></span>
                            </a>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <a href="https://thelibertychurchlondon.com/give/" target="_" className="featured-block">
                                <img src="https://ik.imagekit.io/seyi/Tlc_Media/Site_Images/giving.png" alt="" className="fblock-image"/>
                                <div className="fblock-image-overlay"></div>
                                <span className="fblock-text"><span className="fblock-text-tb">
                                    <span className="fblock-text-tbcell"><strong>Give to the TheLibertyChurch</strong></span>
                                </span></span>
                            </a>
                        </div>
                    </div>
               	</div>
            </div>
            
            <div className="padding-tb75" style={{textAlign:'center'}}>
            	<div className="container" style={{textAlign:'center'}}>
                	<div className="row" style={{textAlign:'center'}}>
                    	<div className="col-md-12" style={{textAlign:'center'}}>
                        	<h2 style={{color: "#003165"}} className="block-title"><strong>Upcoming Events</strong></h2>
                            <div className="spacer-20"></div>
                            	<ul className="events-compact-list">
                                    {events.filter(event =>
                                        event['team_members_only'] === 'False' &&
                                        event['enabled'] === '1' &&
                                        moment(event['event_date'], 'YYYY-MM-DD HH:mm:ss').isSameOrAfter(moment(), 'day')
                                    ).map((event, id) => (
                                        <li key={id} className="event-list-item">
                                            <span style={{backgroundColor: "#ffa800"}} className="event-date">
                                                <span className="date">{moment(event['event_date']).format('DD')}</span>
                                                <span className="month">{moment(event['event_date']).format('MMM')}</span>
                                                <span className="year">{moment(event['event_date']).format('YYYY')}</span>
                                            </span>
                                            <div className="event-list-cont">
                                                <span className="meta-data">{moment(event['start_time']).format('dddd, HH:mm')} - {moment(event['end_time']).format('HH:mm')}</span>
                                                <h4 className="post-title"><a style={{color: "#003165"}} href={ isLoggedIn ? "/eventsdetails?id=" + event['id'] : "/eventdetailsnon?id=" + event['id']}>{event['name']}</a></h4>
                                                <p>{event['description']}</p>
                                                <a href={ isLoggedIn ? "/eventsdetails?id=" + event['id'] : "/eventdetailsnon?id=" + event['id']} className="btn btn-default">Details</a>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                        </div>
                        <div className="spacer-40 visible-sm visible-xs"></div>
                    	
                    </div>
                </div>
            </div>
            {
                isLoggedIn && loggedInUser && loggedInUser['role.name'] !== 'checklist_viewer' ?
                <div className="parallax parallax5 parallax-light text-align-center padding-tb100" style={{backgroundColor:"#ffa800"}}>
                    <h2><strong>Readiness checks<br/>before going Live</strong></h2>
                    <a href="/readinesscheck" className="parallax-icon-link"><i className="fa fa-5x fa-play-circle-o"></i></a>
                </div>:<></>
            }

            {
                isLoggedIn && loggedInUser && loggedInUser['role.name'] !== 'checklist_viewer' ?
                <div className="padding-tb75 padding-b0">
            	<div className="container">
                    <div style={{textAlign: 'center', marginBottom: '10px'}}>
                        <h2 className="block-title" style={{color: '#003165'}}>New to the Team</h2>
                        <p style={{color: '#666', maxWidth: '600px', margin: '0 auto', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>Resources to help you get started</p>
                    </div>
                    <div className="spacer-20"></div>
                    <Slider {...settings}>
                        {[
                            { title: 'Welcome and Overview', image: 'https://ik.imagekit.io/seyi/Tlc_Media/Site_Images/documentation.jpg', href: '/documentation', target: undefined },
                            { title: 'Media Detailed Operation', image: 'https://ik.imagekit.io/seyi/Tlc_Media/Site_Images/mediaops.jpg', href: 'https://drive.google.com/file/d/1Crkl9sFW-fn8m2TRQyVJ64uECOv3iUp3/view', target: '_blank' },
                            { title: 'Liberty Point Setup', image: 'https://ik.imagekit.io/seyi/Tlc_Media/Site_Images/libertypointsetup.jpg', href: 'https://docs.google.com/file/d/1K4WyEXa3KMtG6HLFTNwS72aW89RGpszO/edit?usp=docslist_api&filetype=msexcel', target: '_blank' }
                        ].map((card, idx) => (
                            <div key={idx} style={{padding: '0 8px'}}>
                                <a href={card.href} target={card.target} style={{textDecoration: 'none', display: 'block'}}>
                                    <div style={{backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0', overflow: 'hidden'}}>
                                        <div style={{width: '100%', aspectRatio: '16/9', overflow: 'hidden'}}>
                                            <img src={card.image} alt="" style={{width: '100%', height: '100%', objectFit: 'cover'}}/>
                                        </div>
                                        <div style={{padding: '14px 16px'}}>
                                            <h4 style={{color: '#ffa800', margin: 0, fontSize: 'clamp(14px, 3.8vw, 16px)', fontWeight: 'bold'}}>{card.title}</h4>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div> : <></>
            }            
            
        </div>
    </div>


    
		<Footer/>
   

    </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };
    
};


export default connect(mapStateToProps)(Index);
